module.exports = "https://static.wagwalking.com/_next/static/images/icon_paw_bold-b836273123d1876cc43b745ab7ce3543.svg";